<template>
  <section class="user_review_section" v-show="user">
    <div class="container">

<div class="main-visual row" style="margin-bottom: 14px; text-align: center;">

<div class="mobile" style="font-family: 'Black Han Sans', sans-serif; font-size: 42px; width: 100%; text-align: left">
내돈내놔<br>성공사례
</div>
<span class="mobile" style="font-size: 18px; font-weight: bold; line-height: 2.0; width: 100%; color: black; text-align: left; margin-top: 20px; margin-bottom: 20px;">
내돈내놔를 통해 채권추심에 성공한<br>사례들을 공유합니다.
</span>

<h3 class="desktop" style="font-family: 'Black Han Sans', sans-serif; font-size: 42px; width: 100%; text-align: left; margin-top: -50px;">
내돈내놔 성공사례
</h3>
<span class="desktop" style="font-size: 18px; font-weight: bold; line-height: 2.0; width: 100%; color: black; text-align: left;">
내돈내놔를 통해 채권추심에 성공한 사례들을 공유합니다.
</span>

        <div class="content_box" style="margin-top: 20px; padding-left: 0px; padding-right: 0px; width: 100%;" >
          <div class="card_box" style="padding-left: 0px; padding-right: 0px; max-width: 800px;">
            <ul class="card_content">
              <li
                v-for="list in lists"
                :key="list.id"
                :class="[
                                    list.type === 1 && 'drunk',
                                    list.type === 2 && 'porno',
                                    list.type === 3 && 'c',
                                    list.type === 4 && 'd'
                                ]"
              >
                <button @click="datile(list.id)">
                  <div class="content" style="color: black; width: 100%;">회수금액 <div style="display:inline; text-align: right;">{{ list.order_number }} 원</div></div>
                  <div class="span_box">
                    <span class="name" style="color: black;">원금대비</span>
                    <span class="date" style="text-align: left;">
                      {{
                      list.user_id
                      }}%
                    </span>
                  </div>

                  <div class="span_box">
                    <span class="name" style="color: black; letter-spacing: 1px;">의 뢰 인</span>
                    <span class="date"  style="text-align: left; ">
                      {{
                      list.user_email
                      }}
                    </span>
                  </div>

                  <div class="span_box">
                    <span class="name" style="color: black; letter-spacing: 1px;">의 뢰 일</span>
                    <span class="date" style="text-align: left; ">
                      {{
                      list.content
                      }}
                    </span>
                  </div>

                  <div class="span_box">
                    <span class="name" style="color: black; letter-spacing: 1px;">회 수 일</span>
                    <span class="date"  style="text-align: left; ">
                      {{
                      list.content2
                      }}
                    </span>
                  </div>
                </button>
              </li>
            </ul>
            <center>
            <div class="btn-box" style="display: block;">
              <button @click="plusList" v-show="btnResult" style="background-color: #343a40;">더보기</button>
            </div>
            </center>
          </div>
       </div>
</div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      lists: [],
      popup: [],
      isActive: false,
      btnLast: true,
      btnFirst: true,
      start: true,
      last: "",
      first: 1,
      num: 5,
      btnResult: true,
      user: false
    };
  },
  mounted() {
    this.userReviewAPI();
  },
  methods: {
    async userReviewAPI() {
      try {
        const res = await axios({
          method: "GET",
          url: `/api/review`
        });
        // console.log(res);

        if (res.data.now.length > 0) {
          this.user = true;
          this.last = res.data.now[0].id;
          this.lists = res.data.now.map(v => {
            const email = v.user_email.split("@");
            //v.user_email = `${email[0].substring(0, 2)}***`;
            const created_at = v.created_at.split(" ");
            v.created_at = created_at[0];
            const updated_at = v.updated_at.split(" ");
            v.updated_at = updated_at[0];
            if (v.content.length > 200) {
              v.preview = `${v.content.substring(0, 200)}...`;
            } else {
              v.preview = v.content;
            }

            return v;
          });
          if (res.data.next.length < 1) {
            this.btnResult = false;
          }
        }
      } catch (e) {
        // console.log(e);
      }
    },

    async plusList() {
      try {
        const res = await axios({
          method: "GET",
          url: `/api/review/${this.num}`
        });
        const listAdd = res.data.now.map(v => {
          const email = v.user_email.split("@");
          //v.user_email = `${email[0].substring(0, 2)}***`;
          const created_at = v.created_at.split(" ");
          v.created_at = created_at[0];
          if (v.content.length > 200) {
            v.preview = `${v.content.substring(0, 200)}...`;
          } else {
            v.preview = v.content;
          }
          return v;
        });
        if (res.data.next.length < 1) {
          this.btnResult = false;
        }
        this.lists = [...this.lists, ...listAdd];
        this.num = this.num + 5;
      } catch {}
    },

    async datile(id) {
      try {
        const res = await axios({
          method: "GET",
          url: `/api/review/get/${id}`
        });

        this.resultData(res.data.now);
        this.isActive = true;
        if (!res.data.prev) {
          this.btnFirst = false;
        } else {
          this.btnFirst = true;
        }
      } catch {}
    },

    async nextMove(id) {
      if (this.start) {
        this.start = false;
        try {
          const res = await axios({
            method: "GET",
            url: `/api/review/next/${id}`
          });
          this.start = true;
          // console.log(res);
          this.resultData(res.data);
          this.btnFirst = true;
        } catch {}
      }
    },
    async prevMove(id) {
      if (this.start) {
        this.start = false;
        try {
          const res = await axios({
            method: "GET",
            url: `/api/review/prev/${id}`
          });
          this.start = true;
          // console.log(res);
          this.resultData(res.data.now);
          if (!res.data.prev) {
            this.btnFirst = false;
          } else {
            this.btnFirst = true;
          }
        } catch {}
      }
    },
    offdatile() {
      this.isActive = false;
    },
    resultData(res) {
      if (this.last === res.id) {
        this.btnLast = false;
      } else {
        this.btnLast = true;
      }

      const email = res.user_email.split("@");
      //res.user_email = `${email[0].substring(0, 2)}***`;
      res.user_email = `${email[0]}`;
      const created_at = res.created_at.split(" ");
      res.created_at = created_at[0];
      this.popup = res;
    }
  }
};
</script>

<style scoped>
.user_review_section {
  /* padding-top: 40px; */
  padding: 40px 0;
  background: #fff;
}

.user_review_section .title h2 {
  color: #2e2d2d;
  font-size: 1.875rem;
  font-weight: bold;
  margin-bottom: 0;
  padding-bottom: 40px;
}

.content_box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.content_box .card_box {
  width: 100%;
  order: 2;
}

.content_box .card_box li {
  background-color: #fff;
  border: 1px solid #e7e7e7;
  box-shadow: 0 30px 60px 12px rgba(0, 0, 33, 0.05),
    0 4px 24px 0 rgba(0, 0, 33, 0.05), 0 0 1px 0 rgba(0, 0, 33, 0.09);
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;
}

/* .content_box .card_box li::before {
  content: "";
  display: block;
  width: 10px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: #fb6037;
} */
/* .content_box .card_box li.drunk::before {
  background-color: #f0b756;
} */
/* .content_box .card_box li::before {
  background-color: #475fae;
} */

.content_box .card_box li button {
  display: block;
  padding: 20px;
  box-sizing: border-box;
  width: 100%;
  text-align: left;
}

.content_box .card_box li .content {
  font-size: 18px;
  font-weight: bold;
  color: #362e2c;
  padding-bottom: 15px;
  border-bottom: 1px solid #d5d5d5;
  box-sizing: border-box;
  word-break: keep-all;
  word-wrap: break-word;
}

.content_box .card_box li .span_box {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1;
  font-weight: bold;
}

.content_box .card_box li .span_box .name {
  color: #196bed;
  font-size: 16px;
  padding-right: 5px;
  font-weight: bold;
}

.content_box .card_box li .span_box .date {
  color: #737373;
  font-size: 16px;
  padding-left: 5px;
  font-weight: bold;
  flex: 1;
  text-align: right;
}

.content_box .card_box .btn-box {
  display: block;
}

.content_box .guide_box {
  width: 100%;
  order: 1;
}

.content_box .guide_box .guide_content {
  position: sticky;
  right: 0;
  top: 120px;
  margin-bottom: 20px;
}

.content_box .guide_box .title {
  font-size: 24px;
  font-weight: bold;
  color: #454f5c;
  /* text-align: center; */
}

.content_box .guide_box span {
  display: block;
  width: 20px;
  height: 2px;
  background-color: #000;
  margin: 20px 0;
}

.content_box .guide_box .txt {
  font-size: 16px;
  color: #454f5c;
  /* text-align: center; */
  /* font-weight: bold; */
}

.content_box .guide_box .btn-box {
  display: none;
}

.content_box .btn-box {
  margin-top: 45px;
}

.content_box .btn-box button {
  display: block;
  height: 60px;
  line-height: 60px;
  color: #fff;
  background-color: #207bf9;
  font-weight: bold;
  text-align: center;
  width: 300px;
  border-radius: 10px;
  margin: 0 auto;
  font-size: 16px;
}

@media screen and (min-width: 992px) {
  .user_review_section {
    padding: 100px 0;
  }
  .content_box .card_box {
    order: 1;
    max-width: 500px;
  }
  .content_box .card_box .btn-box {
    display: none;
  }

  .content_box .guide_box {
    order: 2;
    max-width: 400px;
  }

  .content_box .guide_box .btn-box {
    display: block;
  }
  .content_box .guide_box .title {
    font-size: 38px;
    text-align: left;
  }

  .content_box .btn-box button {
    margin: initial;
  }
}

/* .span_box.left {
  justify-content: flex-start;
}
.span_box.left .name {
  border-right: 1px solid #c5c4c2;
}

.name {
  color: #fb6037;
  font-size: 16px;
  padding-right: 5px;
}

.date {
  color: #737373;
  font-size: 16px;
  margin-left: 5px;
} */

/* .content_box ul li {
  border: 1px solid #e7e7e7;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 30px 60px 12px rgba(0, 0, 33, 0.05),
    0 4px 24px 0 rgba(0, 0, 33, 0.05), 0 0 1px 0 rgba(0, 0, 33, 0.09);
  margin-bottom: 30px;
}

.content_box ul li > button {
  display: block;
  width: 100%;
  text-align: left;
  padding: 25px 25px 10px 25px;
}

.content_box ul li .content {
  font-size: 18px;
  font-weight: bold;
  color: #362e2c;
  padding-bottom: 20px;
  border-bottom: 1px solid #d5d5d5;
} */

.span_box button {
  font-size: 12px;
  color: #fb6037;
  padding-bottom: 3px;
  border-bottom: 1px solid #fb6037;
  margin-left: auto;
}

.review_popup {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: none;
  padding: 10px 40px;
}

.review_popup.active {
  display: flex;
  align-items: center;
}

.review_popup .popup_content {
  min-height: 300px;
  max-width: 500px;
  width: 100%;
  margin: auto;
  position: relative;
  z-index: 100;
  background-color: #fff;
  padding: 16px 16px 30px 16px;
  box-sizing: border-box;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  background-color: #e2e4e6;
}

.review_popup .close_btn {
  position: absolute;
  right: -40px;
  top: 0;
  width: 40px;
  height: 40px;
}

.review_popup .close_btn span {
  position: absolute;
  left: 0;
  top: 50%;
  width: 100%;
  height: 2px;
  background-color: #fff;
}

.review_popup .close_btn span.line1 {
  transform: translateY(-50%) rotate(45deg);
}

.review_popup .close_btn span.line2 {
  transform: translateY(-50%) rotate(-45deg);
}

.item_conent {
  margin-top: 20px;
  white-space: pre-line;
  min-height: 250px;
  max-height: 500px;
  overflow: auto;
  padding: 15px;
  color: #372f2c;
  font-size: 16px;
  border-radius: 4px;
  background-color: #fff;
}

.review_popup .back {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.popup_content .pagination-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.popup_content .pagination-btn.left {
  left: -40px;
}

.popup_content .pagination-btn.right {
  right: -40px;
}
</style>
